import { render, staticRenderFns } from "./ExibirCategoriaRepresentativa.vue?vue&type=template&id=691ce206&scoped=true&"
import script from "./ExibirCategoriaRepresentativa.vue?vue&type=script&lang=js&"
export * from "./ExibirCategoriaRepresentativa.vue?vue&type=script&lang=js&"
import style0 from "./ExibirCategoriaRepresentativa.vue?vue&type=style&index=0&id=691ce206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691ce206",
  null
  
)

export default component.exports